import React, { useState, useContext } from "react";
import { Container, Card } from "../components/Layout";
import ProgressButton from "../components/ProgressButton";
import styled from "styled-components";
import { ToastContext } from "../contexts/ToastProvider";

const Wrapper = styled.div`
  gap: 10px;
  justify-content: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const ButtonCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  background-color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.primary : theme.colors.white};
  color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.white : theme.colors.primary};
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: ${({ isChecked, theme }) =>
      isChecked ? theme.colors.primary : theme.colors.background};
  }
`;

function Step3({ onNext, onBack }) {
  const [selectedFactors, setSelectedFactors] = useState([]);
  const { toast } = useContext(ToastContext);

  const riskFactors = [
    "Forhøjet kolesterol (LDL >4,0 mM)",
    "Type 2 Diabetes",
    "Hjertesygdomme (forhøjet blodtryk, tidligere blodprop i hjerte)",
    "Søvnapnø",
    "Forøget talje mål (>102 cm mænd, >88 cm kvinder)",
    "PCOS (Polycystisk ovariesyndrom)",
    "Vægtrelateret cancer",
    "Ingen af ovenstående",
  ];

  const handleToggle = (factor) => {
    if (factor === "Ingen af ovenstående") {
      if (!selectedFactors.includes(factor)) {
        setSelectedFactors([factor]);
      } else {
        setSelectedFactors([]);
      }
    } else {
      if (selectedFactors.includes("Ingen af ovenstående")) {
        return;
      }

      if (selectedFactors.includes(factor)) {
        setSelectedFactors(selectedFactors.filter((item) => item !== factor));
      } else {
        setSelectedFactors([...selectedFactors, factor]);
      }
    }
  };

  const handleNext = () => {
    if (!selectedFactors.length) {
      toast.error("Vælg mindst én risikofaktor.");
      return;
    }
    onNext(selectedFactors);
  };

  const isNextDisabled =
    selectedFactors.length === 1 &&
    selectedFactors.includes("Ingen af ovenstående");

  return (
    <Container>
      <Card>
        <h1>Risikofaktorer</h1>
        <Wrapper>
          {riskFactors.map((factor, index) => (
            <ButtonCheckbox
              key={index}
              isChecked={selectedFactors.includes(factor)}
              onClick={() => handleToggle(factor)}
            >
              {factor}
            </ButtonCheckbox>
          ))}
        </Wrapper>
        <div>
          <ProgressButton text="Tilbage" onClick={onBack} />
          {!isNextDisabled && (
            <ProgressButton text="Videre" onClick={handleNext} />
          )}
        </div>
      </Card>
    </Container>
  );
}

export default Step3;
